/* Pure helpers for the job openings filter app */

export const workplaceTypeLabels = {
	remote: 'Remote',
	hybrid: 'Hybrid',
	onsite: 'In-office',
};

const workplaceTypeOrder = ['remote', 'hybrid', 'onsite'];

/* Sort an array of term objects alphabetically, with a fixed order for workplace types */
export const sortTerms = (taxonomy, a, b) => {
	if (taxonomy === 'workplaceTypes') {
		const indexA = workplaceTypeOrder.indexOf(a.key);
		const indexB = workplaceTypeOrder.indexOf(b.key);
		const orderA = indexA === -1 ? workplaceTypeOrder.length : indexA;
		const orderB = indexB === -1 ? workplaceTypeOrder.length : indexB;

		if (orderA !== orderB) {
			return orderA - orderB;
		}
	}

	if (a.term < b.term) {
		return -1;
	}

	if (a.term > b.term) {
		return 1;
	}

	return 0;
};

/* Set a taxonomy filter value on the store, normalising to an array */
export const setFilter = (store, selection, type) => {
	if (Array.isArray(selection)) {
		store.filter[type] = selection.length > 0 ? selection : [];
	} else if (selection) {
		store.filter[type] = [selection];
	} else {
		store.filter[type] = [];
	}
};

/*
 * Filter postings with OR within a taxonomy and AND across taxonomies.
 * An empty selection for a taxonomy matches every posting.
 */
export const getFilteredPostings = (postings, departments, locations, workplaceTypes) => postings.filter(posting => {
	const isDepartmentMatch = departments.length === 0 || departments.includes(posting.department);
	const isLocationMatch = locations.length === 0 || posting.locations.some(location => locations.includes(location));
	const isWorkplaceMatch = workplaceTypes.length === 0 || workplaceTypes.includes(posting.workplaceType);

	return isDepartmentMatch && isLocationMatch && isWorkplaceMatch;
});

/* Group filtered postings by department, preserving first-seen (alphabetical source) order */
export const groupPostingsByDepartment = postings => {
	const teamMap = new Map();

	for (const posting of postings) {
		if (!teamMap.has(posting.department)) {
			teamMap.set(posting.department, []);
		}

		teamMap.get(posting.department).push(posting);
	}

	return [...teamMap.entries()].map(([title, teamPostings]) => ({
		title,
		postings: teamPostings,
	}));
};

/* Populate store taxonomies and postings from the page-supplied board data */
export const loadPostings = (store, postings) => {
	const departments = {};
	const locations = {};
	const workplaceTypes = {};

	for (const posting of postings) {
		if (posting.department) {
			departments[posting.department] = posting.department;
		}

		for (const location of posting.locations || []) {
			locations[location] = location;
		}

		if (posting.workplaceType) {
			workplaceTypes[posting.workplaceType] = workplaceTypeLabels[posting.workplaceType] || posting.workplaceType;
		}
	}

	store.departments = departments;
	store.locations = locations;
	store.workplaceTypes = workplaceTypes;
	store.postings = postings;
	store.ready = true;
};
